/** @jsxImportSource preact */
import {computed, useSignal} from '@preact/signals'
import {useEffect, useRef} from 'preact/hooks';

function FieldWrapper({children, id, className}) {
    return <div id={id} className={`input-field col s12 ${className}`} style={{clear: 'both'}}>
        {children}
    </div>
}

interface IFormErrors {
    [key: string]: string[] | undefined; // e.g., { password: ["Novo geslo je prekratko"], password_test: ["Gesli nista enaki"] }
}

interface ITools {
    [key: string]: string[] | undefined; // e.g., { password: ["Novo geslo je prekratko"], password_test: ["Gesli nista enaki"] }
}


interface IFieldProps {
    i: number,
    data?: Record<string, any>; // Flexible data object (e.g., form input values or API response)
    tools?: {
        formErrors?: IFormErrors;
        tools?: ITools;
        settings: any
    }
}

function Field({i, data = {}, tools = null}: IFieldProps) {
    const {formErrors, postData, settings} = tools
    const fieldValue = !formErrors[data.name] ? postData[data.name] : null
    const countries = JSON.parse(document.getElementById('countries')?.textContent || '[]')

    var autocompleteCLass = ''
    if(data.name == 'street_1') autocompleteCLass =  'autocomplete-street'
    if(data.name == 'city') autocompleteCLass =  'autocomplete-city'
    if(data.name == 'postal_code') autocompleteCLass = 'autocomplete-post'

    if (data.type == 'div') return <>
        <div id={`wrapper_id_${data.name}`} className={data.visibility === false ? 'hidden' : ''}
             style={'padding: 0 0 2rem 0;'} dangerouslySetInnerHTML={{__html: data.label || data.placeholder}}></div>
    </>

    if (data.type == 'checkbox') return <>
        <FieldWrapper id={`wrapper_id_${data.name}`} className={data.visibility === false ? 'hidden' : ''}>
            <div style={{minHeight: '30px', clear: 'both'}}>
                <label>
                    <input type={data.type} name={data.name} id={`id_${data.name}`} checked={fieldValue === 'on'}
                           onClick={data.onClick}/>
                    <span>
                        {/*<span className={'hidden'} style="text-transform: uppercase;">{data.placeholder}</span> {data.required && <span className="star">*</span>}*/}
                        {/*<br />*/}
                        <span
                            dangerouslySetInnerHTML={{__html: data.label || data.placeholder}}></span> {data.required &&
                        <span className="star">*</span>}
                    </span>
                </label>
                {formErrors[data.name] &&
                    <ul className="errorlist">
                        {formErrors[data.name].map((e: string) => <li>{e}</li>)}
                    </ul>
                }
            </div>
        </FieldWrapper>
    </>

    {
        if (data.type === 'select') return <>
            <FieldWrapper id={`wrapper_id_${data.name}`} className={data.visibility === false ? 'hidden' : ''}>
                <select name={data.name} className={`ella_countries`} id={`id_${data.name}`}
                        placeholder={data.placeholder}>
                    {countries.map(c => <option value={c.id} selected={c.id == 203}>{c.name}</option>)}
                </select>
                <label htmlFor={data.name} class={'active'}>{data.label || data.placeholder} {data.required &&
                    <span className="star">*</span>}</label>
                {formErrors[data.name] &&
                    <ul className="errorlist">
                        {formErrors[data.name].map((e: string) => <li>{e}</li>)}
                    </ul>
                }
            </FieldWrapper>
        </>
    }

    return <FieldWrapper id={`wrapper_id_${data.name}`} className={data.visibility === false ? 'hidden' : ''}>
        <input type={data.type} name={data.name} placeholder={data.placeholder} maxLength={data.maxlength} required=""
               id={`id_${data.name}`} value={fieldValue} className={autocompleteCLass}/>
        <label htmlFor={data.name}>{data.label || data.placeholder} {data.required &&
            <span className="star">*</span>}</label>
        {formErrors[data.name] &&
            <ul className="errorlist">
                {formErrors[data.name].map((e: string) => <li>{e}</li>)}
            </ul>
        }
    </FieldWrapper>

}

export default Field